module.exports = __webpack_public_path__ + "static/media/bg_audio.9cf97568.wav";